import { render, staticRenderFns } from "./orcidSearchTutorial.vue?vue&type=template&id=01aec5bd&scoped=true&ref=orcid_tutorial"
import script from "./orcidSearchTutorial.vue?vue&type=script&lang=js"
export * from "./orcidSearchTutorial.vue?vue&type=script&lang=js"
import style0 from "./orcidSearchTutorial.vue?vue&type=style&index=0&id=01aec5bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aec5bd",
  null
  
)

export default component.exports